"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateProp = void 0;
/**
 * This function takes in the properties of a component one of which is the translation property "t".
 * It uses these properties to provide a default translation for the property if the property is not specified
 * @param props Object that contains either the pre-translated string via `props[propName]` or the i18next translation function via `props.t(tString)`
 * @param propName name of prop that is the already-translated string
 * @param tString fallback i18next key
 * @returns Translated string if found, otherwise `undefined`
 * @deprecated Will be removed in a future major version
 */
var translateProp = function (props, propName, tString) {
    return typeof props[propName] !== 'undefined'
        ? props[propName]
        : props.t
            ? props.t(tString)
            : undefined;
};
exports.translateProp = translateProp;
//# sourceMappingURL=localization.js.map